import { Injectable } from '@angular/core';
import { REGEX, MGA_UPLOAD, IMG_DEFAULT, ITEMS_PER_PAGE } from '../../shared/constants';
import { environment } from '../../../environments/environment';
import { empty } from 'rxjs/Observer';

@Injectable()
export class BaseHelperService {
  static randomId(prefix: string = "") {
    return prefix + Math.random().toString(36).substr(2, 9);
  }

  static capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  static getLastPathVariable(uri) {
    return uri.substr(uri.lastIndexOf('/') + 1);
  }

  static getContainer(uri) {
    return uri.split('/')[1];
  }

  static getAcceptFileExtension(container) {
    if (container === MGA_UPLOAD.CONTAINER.IMAGE) {
      return MGA_UPLOAD.ACCEPT_FILE_EXTENSION.IMAGE;
    } else if (container === MGA_UPLOAD.CONTAINER.VIDEO) {
      return MGA_UPLOAD.ACCEPT_FILE_EXTENSION.VIDEO;
    } else if (container === MGA_UPLOAD.CONTAINER.AUDIO) {
      return MGA_UPLOAD.ACCEPT_FILE_EXTENSION.AUDIO;
    }
    return MGA_UPLOAD.ACCEPT_FILE_EXTENSION.DEFAULT;
  }

  static deleteIndexProp(list) {
    const listResult = [];
    if (list.length > 0) {
      for (const item of list) {
        if (item.hasOwnProperty('index')) {
          const { index, ...result } = item;
          listResult.push(result);
        } else {
          listResult.push(item);
        }
      }
    }
    return listResult;
  }

  static convertMultiChoiceItems(listSrc: any) {
    const listDes = [];
    for (const item of listSrc) {
      if (!item.hasOwnProperty('tId')) {
        item['itemName'] = item.title;
        listDes.push(item);
      }
    }
    return listDes;
  }

  static convertSelectedItemsToListId(listSrc: any) {
    const list = [];
    for (const item of listSrc) {
      list.push(item.id);
    }
    return list;
  }

  static convertListIdToSelectedItems(listSrc: any) {
    const list = [];
    for (const item of listSrc) {
      item['itemName'] = item.title;
      list.push(item);
    }
    return list;
  }

  static getFullUrl(uri) {
    if (uri) {
      return environment.baseUrl + uri;
    }
    return IMG_DEFAULT;
  }

  static getListContentName(list) {
    const result = [];
    for (const item of list) {
      result.push(item.title);
    }
    return result;
  }

  static calcTotalPage(count, pageSize?: any) {
    pageSize = pageSize || ITEMS_PER_PAGE;
    return Math.ceil(count / pageSize);
  }

  static calcOffset(page, pageSize?: any) {
    pageSize = pageSize || ITEMS_PER_PAGE;
    return (page - 1) * pageSize;
  }

  static filterTextInDataset(text?: string, list?: any) {
    const result = [];
    for (const item of list) {
      if (item.meaning.indexOf(text) !== -1) {
        result.push(item.id);
      }
    }
    return result;
  }

  static isValidNumber(number: string) {
    return REGEX.NUMBER.test(number);
  }

  static transformCapitalize(value: any) {
    if (value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
    return value;
  }

  static convertToSearchString(text: string) {
    var str = text;
    if (str.length !== 0) {
      str = str.toLowerCase();
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
      str = str.replace(/ + /g, " ");
      str = str.trim();
    }
    return str;
  }

  static getRandom(array){
    let m = array.length, t, i;
    while (m) {
      i = Math.floor(Math.random() * m--);
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }
    return array;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/helper/base.service.ts